/**
 * useSavedFilters — load and mutate a user's saved filter sets for a module.
 * Thin wrapper over the /api/dashboard/v2/filters CRUD endpoints.
 */
import { useCallback, useEffect, useState } from 'react';
import {
  listSavedFilters, saveFilter, deleteSavedFilter,
} from '../api/client';

export function useSavedFilters(module) {
  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!module) return;
    setLoading(true);
    try {
      setFilters(await listSavedFilters(module));
    } catch {
      /* leave existing list on transient error */
    } finally {
      setLoading(false);
    }
  }, [module]);

  useEffect(() => { reload(); }, [reload]);

  const save = useCallback(async (name, filterObj, isShared = false) => {
    await saveFilter({ module, name, filters: filterObj, is_shared: isShared });
    await reload();
  }, [module, reload]);

  const remove = useCallback(async (id) => {
    await deleteSavedFilter(id);
    await reload();
  }, [reload]);

  return { filters, loading, reload, save, remove };
}

export default useSavedFilters;
